import classNames from 'classnames';
import InfoPopover from 'components/ui/InfoPopover/InfoPopover';
import React, {useRef} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import ErrorFeedback from '../ErrorFeedback/ErrorFeedback';
import {IDefaultControlProps} from '../Form/Form';

import styles from './AmnisSwitch.module.scss';

export interface ISwitchProps {
    labelPosition?: 'left' | 'right' | 'top';
    defaultValue?: boolean;
}

const AmnisSwitch = (props: IDefaultControlProps & ISwitchProps) => {
    const {
        className,
        disabled,
        info,
        label,
        labelPosition = 'right',
        name,
        onChange,
        defaultValue = false,
        readOnly,
    } = props;
    const {errors, control} = useFormContext();
    const inputRef = useRef<HTMLInputElement | null>(null);

    const labelElement = (
        <label
            htmlFor={name}
            className={classNames(styles.label, {
                [styles.disabled]: disabled || readOnly,
            })}
        >
            {label}
            {info ? <InfoPopover content={info}/> : null}
        </label>
    );

    return (
        <div
            className={classNames(styles.container, className, {
                [styles.vertical]: labelPosition === 'top',
            })}
        >
            {labelPosition === 'left' || labelPosition === 'top'
                ? labelElement
                : null}
            <button
                type="button"
                onClick={() => inputRef.current?.click()}
                className={styles.switch}
                disabled={disabled || readOnly}
            >
                <Controller
                    control={control}
                    name={name}
                    defaultValue={defaultValue}
                    render={({value, ...restRenderProps}) => {
                        return (
                            <input
                                {...restRenderProps}
                                ref={inputRef}
                                onChange={e => {
                                    if (onChange) onChange(e);
                                    restRenderProps.onChange(e.target.checked);
                                }}
                                type="checkbox"
                                id={name}
                                checked={value}
                                disabled={disabled}
                                readOnly={readOnly}
                            />
                        );
                    }}
                />
                <span
                    className={classNames(styles.slider, {
                        [styles.disabled]: disabled || readOnly,
                    })}
                />
            </button>
            {labelPosition === 'right' ? labelElement : null}
            {errors[name]?.message ? (
                <ErrorFeedback message={errors[name].message}/>
            ) : null}
        </div>
    );
};

export default AmnisSwitch;
